import React from "react";

export const typedMemo: <T>(c: T) => T = React.memo;
export type Optional<T> = T | undefined;

export enum YesNoAnswer {
  YES = "yes",
  NO = "no",
}

